import { combineReducers } from '@reduxjs/toolkit'

import appointments from './appointmentsSlice'
import ltClient from './ltClientSlice'
import assignments from '../../../assignments/data/assignmentsSlice'

export default combineReducers({
  assignments,
  appointments,
  ltClient,
})
